/**
 * live.screen — optional / beta.
 * Interface stub so multi-engine scaffold stays complete.
 * Full ScreenAgent / UI-TARS companion may ship later with explicit trust UX.
 */

import type { EngineContext, VisionEngine } from "./types";

export function createScreenEngine(): VisionEngine {
  let started = false;

  return {
    id: "screen",
    kind: "live",
    label: "Screen (soon)",
    description: "Screen → agent actions. Desktop companion + trust UI required. Not GA.",
    status: "coming-soon",

    async start(ctx: EngineContext) {
      started = true;
      ctx.onEvent?.({
        type: "status",
        message:
          "Screen mode is reserved for a future desktop companion with explicit trust UI. Use Live hands (free) or Ask with suite engines.",
        level: "warn",
      });
    },

    stop() {
      started = false;
    },

    async health() {
      return {
        ok: false,
        detail: started ? "reserved — not wired" : "not started (coming soon)",
      };
    },
  };
}
